import React, { useState, useEffect } from "react";
import { ArrowLeft } from "lucide-react";
import { Link } from "react-router-dom";
import Navbar from "../../sub-comp/Navbar";
import FullScreenImage from "../../Home/ShowcaseSection";
import Footer from "../../sub-comp/MainFooter";

const CybersecurityProgram = ({
  backLink,
  heroTitle,
  heroSubtitle,
  heroImage,
  introParagraphs,
  classroom,
  beyondClassroom,
  difference,
}) => {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    setIsVisible(true);
  }, []);

  return (
    <div>
      <Navbar />
      <div className="min-h-screen bg-white text-black overflow-hidden relative">
        {/* Hero Section */}
        <section
          className={`relative h-[70vh] flex items-center justify-center transition-all duration-1000 ${
            isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-10"
          }`}
        >
          <img
            src={heroImage}
            alt={heroTitle}
            className="absolute inset-0 w-full h-full object-cover"
          />
          <div className="absolute inset-0 bg-black/40"></div>
          <div className="relative z-10 text-center text-white">
            <h1 className="text-5xl md:text-6xl font-bold mb-4">{heroTitle}</h1>
            <p className="max-w-2xl mx-auto text-lg">{heroSubtitle}</p>
          </div>
        </section>

        {/* Main Content */}
        <div className="relative z-10 max-w-7xl mx-auto px-6 pb-20">
          {/* Breadcrumb */}
          <div className="bg-white">
            <div className="max-w-7xl mx-auto px-4 py-4">
              <Link
                to={backLink}
                className="flex items-center text-custom-pink hover:text-custom-pink/70 font-medium transition-all duration-300 hover:translate-x-1 group"
              >
                <ArrowLeft className="w-4 h-4 mr-2 group-hover:-translate-x-1 transition-transform duration-300" />
                Back to IT Programs
              </Link>
            </div>
          </div>

          {/* Introduction Paragraphs */}
          <div
            className={`mb-16 transition-all duration-1000 delay-700 ${
              isVisible
                ? "opacity-100 translate-y-0"
                : "opacity-0 translate-y-10"
            }`}
          >
            {introParagraphs.map((text, idx) => (
              <p key={idx} className="text-lg leading-relaxed mb-6 text-black">
                {text}
              </p>
            ))}
          </div>
        </div>

        {/* In the Classroom Section */}
        <section
          className={`w-full mb-16 transition-all duration-1000 delay-900 ${
            isVisible ? "opacity-100" : "opacity-0"
          }`}
        >
          <div className="w-full bg-custom-pink py-12">
            <div className="max-w-7xl mx-auto px-6 grid md:grid-cols-2 gap-8 items-center">
              <img
                src={classroom.image}
                alt={classroom.title}
                className="w-full h-full object-cover rounded-2xl"
              />
              <div>
                <h2 className="text-4xl font-bold text-white mb-6">
                  {classroom.title}
                </h2>
                {classroom.paragraphs.map((text, idx) => (
                  <p key={idx} className="text-white leading-relaxed mb-6">
                    {text}
                  </p>
                ))}
              </div>
            </div>
          </div>
        </section>

        {/* Beyond the Classroom Section */}
        <section
          className={`w-full mb-16 transition-all duration-1000 delay-1100 ${
            isVisible ? "opacity-100" : "opacity-0"
          }`}
        >
          <div className="w-full relative py-12 bg-white">
            <div className="max-w-7xl mx-auto px-6 grid md:grid-cols-2 gap-8 items-center">
              <div>
                <h2 className="text-4xl font-bold text-custom-pink mb-6">
                  {beyondClassroom.title}
                </h2>
                {beyondClassroom.paragraphs.map((text, idx) => (
                  <p key={idx} className="text-black leading-relaxed mb-6">
                    {text}
                  </p>
                ))}
              </div>
              <div className="relative">
                <img
                  src={beyondClassroom.image}
                  alt={beyondClassroom.title}
                  className="w-full h-full object-cover rounded-2xl"
                />
                <div className="absolute inset-0 bg-white/60 rounded-2xl"></div>
              </div>
            </div>
          </div>
        </section>

        {/* The Difference Section */}
        <section
          className={`w-full transition-all duration-1000 delay-1300 ${
            isVisible ? "opacity-100" : "opacity-0"
          }`}
        >
          <div className="w-full py-12 bg-gray-50">
            <div className="max-w-7xl mx-auto px-6 grid md:grid-cols-2 gap-8 items-center">
              <img
                src={difference.image}
                alt={difference.title}
                className="w-full h-full object-cover rounded-2xl"
              />
              <div>
                <h2 className="text-4xl font-bold text-custom-pink mb-6">
                  {difference.title}
                </h2>
                {difference.paragraphs.map((text, idx) => (
                  <p key={idx} className="text-black leading-relaxed mb-6">
                    {text}
                  </p>
                ))}
              </div>
            </div>
          </div>
        </section>
      </div>
      <FullScreenImage />
      <Footer />
    </div>
  );
};

export default CybersecurityProgram;
